module.exports = __webpack_public_path__ + "static/media/22_pol_0_84_17.ec3bb859.png";